import { render, staticRenderFns } from "./user_checkboxes.vue?vue&type=template&id=4843b92a&lang=pug"
import script from "./user_checkboxes.vue?vue&type=script&lang=js"
export * from "./user_checkboxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports